<script lang="ts">
  import { Portal } from "#lib/internal/components"
  import { getContext, type ComponentProps, type Snippet } from "svelte"

  type Props = ComponentProps<typeof Portal> & {
    children?: Snippet
  }

  let { target = "body", children, ...restProps }: Props = $props()

  // standard key for dialog context
  // Avoid Portal when inside Dialog to prevent z-index issues
  const dialogContext = getContext("dialogKey")
</script>

{#if !dialogContext}
  <Portal {target} {...restProps}>
    {@render children?.()}
  </Portal>
{:else}
  <div class="relative">
    {@render children?.()}
  </div>
{/if}
